module.exports = __webpack_public_path__ + "img/santa-lucia-logo.d945f998.png";